module.exports = __webpack_public_path__ + "static/media/bg-image.4b56aae3.jpeg";